// CANONICAL COPY (GH #7115). src/constants/obligations/obl-test-information-protection.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-test-information-protection',
  title: 'Verify test information is selected, protected and controlled',
  description:
    'Confirm that test information is appropriately selected, protected and controlled to prevent unauthorised exposure of production data in test environments. Where production data is used for testing, it shall be minimised, anonymised or pseudonymised; access to test data shall follow the same controls as production access; copy operations shall be logged and authorised; and test data shall be deleted on completion of testing unless retained under explicit governance. Review the test-information standard and records of production-data-in-test authorisations.',
  category: 'technical',
  scfIds: ['SCF-DEV-009'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Test information standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
